import React, {Component} from 'react';
import styled from 'styled-components';
import SingleHeader from "../components/SingleProduct/SingleHeader";
import {CardTitle} from "../components/Kit/Kit";
import {BodyContainer} from "../components/Container/Container";
import Map from "../components/GoogleMap/Map";
import OtherProducts from "../components/SingleProduct/OtherProducts";

import hngutils from "../assets/libs/hngutils";

const Container = styled.div`
  height: 300px;
  
  @media(min-width: 768px) {
    height: 400px;
  }
  
   @media(min-width: 992px) {
    height: 500px;
  }
  
  // @media(min-width: 1200px) {
  //  height: 750px;
  //}
`;


class SingleProduct extends Component {
    constructor(props) {
      super(props);

      this.props.data.product.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.main_image);
        hngutils.imageSrcToLocalFile(edge.node.acf.image_one);
        hngutils.imageSrcToLocalFile(edge.node.acf.image_two);
        hngutils.imageSrcToLocalFile(edge.node.acf.image_three);
        hngutils.imageSrcToLocalFile(edge.node.acf.other_image);
      });

      this.props.data.list.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.other_image);
      });
      this.props.data.other.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.other_image);
      });
    }

    state = {
        zoom: 2
    };

    componentDidMount() {
        this.updatePredicate();
        window.addEventListener("resize", this.updatePredicate);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updatePredicate);
    }

    updatePredicate = () => {
        if (window.innerWidth < 768) {
            this.setState({zoom: 1});
        } else {
            this.setState({zoom: 2})
        }
    };

    render() {
        const {zoom} = this.state;
        const {title, description, fresh, frozen, main_image, gallery_visible, image_one, image_two, image_three, image_four, locations} = this.props.data.product.edges[0].node.acf;
        const headerData = {
            title,
            description,
            fresh,
            frozen,
            main_image,
            gallery_visible,
            image_two,
            image_one,
            image_three,
            image_four,
        };
        const otherProductList = this.props.data.list.edges.map(i => {
            const {
                acf: {title, other_image: {source_url, alt_text}},
                slug
            } = i.node;
            return {
                title, source_url, alt_text, slug
            }
        });
        const otherImageAll = this.props.data.other.edges.map(i => {
            const {
                acf: {title, slug, other_image: {source_url, alt_text}}
            } = i.node;
            return {
                title, source_url, alt_text, slug
            }
        });
        const productListData = [...otherProductList, ...otherImageAll];

        const latLongArray = [];
        const locationListArray = locations.match(/<li>?(.*?)?<\/li>/g);

        if (locationListArray) {
            const liRegex = /.*<li>\s+(.*)\s+<\/li>.*/;
            locationListArray.map(i => {
                //remove html <li></li> tags
                const item = i.replace(/<\/?[^>]+(>|$)/g, "");
                const rightSide = item.split('=')[1];
                const latAndLong = rightSide.split(';');
                latLongArray.push(latAndLong);
            });
        }
        return (
          <div>
              <SingleHeader data={headerData}/>
              {
                  latLongArray.length ?
                    <BodyContainer><CardTitle>Supplier Locations</CardTitle></BodyContainer> :
                    ''
              }
              {
                  latLongArray.length ?
                    <Map
                      isMarkerShown
                      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyD1wvONHEeeeT7ghz9y-DvewuiHz60iaWw&v=3.exp&libraries=geometry,drawing,places"
                      loadingElement={<div style={{height: `100%`}}/>}
                      containerElement={<Container/>}
                      mapElement={<div style={{height: `100%`}}/>}
                      zoom={zoom}
                      latLongArray={latLongArray}
                    />
                    :
                    ''
              }

              <OtherProducts data={productListData}/>
          </div>
        )
    }
}

export default SingleProduct;

export const singleProductQuery = graphql`
    query ProductQuery($slug: String!) {
        product: allWordpressPost(filter: {slug:{eq: $slug}}) {
            edges {
                node {
                    slug
                    id
                    acf{
                        title
                        description
                        fresh
                        frozen
                        locations
                        main_image {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                        gallery_visible
                        image_one {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                        image_two {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                           
                        }
                        image_three {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                        image_four {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                        other_image {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                    }
                }
            }
        }
        list: allWordpressPost(filter:{acf:{type:{eq:"product"}}}) {
            edges {
                node {
                    slug
                    acf{
                        title
                        other_image {
                            alt_text
                            source_url
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                    }
                }
            }
        }
        other: allWordpressPost(filter:{acf:{type:{eq:"other product"}}}) {
            edges {
                node {
                    acf{
                        title
                        other_image {
                            alt_text
                            source_url
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                        slug
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/templates/single-product.js